import data from './data.json';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import {withRouter} from 'react-router-dom';
import AdminNavigation from './navigation';

const enhance = compose(
	withRouter,
	mapProps(props => ({
		history: props.history,
		privileged: props.privileged,
		items: data
	}))
);

export default enhance(AdminNavigation);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/navigation/index.js